import React, { useState } from "react";
import { Space, Table, Button } from "antd";
import PropTypes from "prop-types";
import { ContactModal } from "./ContactModal";

export const Contacts = ({contacts, onChangeContacts, disabled = false}) => {
	const [openEditContactModal, setEditContactOpenModal] = useState(false);
	const [openAddContactModal, setAddContactOpenModal] = useState(false);  
	const [contactSelected, setContactSelected] = useState({
		name: "",
		phone: "",
		email: "",
	});

	const handleDelete = (record) => {
		const updatedContacts = contacts.filter((contact) => contact.name !== record.name);
		onChangeContacts(updatedContacts);
	};

	const addNewContact = (contact) => {
		onChangeContacts([...contacts, contact]);
	};

	const editContact = (editedContact) => {    
		const updatedContacts = contacts.map((contact) => {
			if (contact.name === contactSelected.name) {
				return editedContact;
			}
			return contact;
		});
		onChangeContacts(updatedContacts);
	};

	const columns = [
		{
			title: "Nombre",
			dataIndex: "name",
			key: "name",
			responsive: ["xs", "sm", "md", "lg", "xl"],
		},
		{
			title: "Telefono",
			dataIndex: "phone",
			key: "phone",
			responsive: ["xs", "sm", "md", "lg", "xl"],
		},
		{
			title: "Correo",
			dataIndex: "email",
			key: "email",
			responsive: ["xs", "sm", "md", "lg", "xl"],
		},
		{
			title: "Accion",
			key: "action",
			responsive: ["xs", "sm", "md", "lg", "xl"],
			render: (_, record) => (
				<Space size="middle">
					<a disabled={disabled} onClick={() => {
						if (disabled) return;

						setContactSelected(record);
						setEditContactOpenModal(true);
					}}>Editar</a>
					<a disabled={disabled} onClick={() => {
						if (disabled) return;

						handleDelete(record);
					}}>Borrar</a>
				</Space>
			),
		},
	];

	return (
		<>        
			<div>
				<Table 
					columns={columns}
					dataSource={contacts}
					footer={() => 
						<Button
							disabled={disabled}
							onClick={() => setAddContactOpenModal(true)}
						>
							Agregar Contacto
						</Button>
					}
					//scroll={{ x: "max-content" }} // Enables horizontal scrolling
				/>
			</div>

			<h4 style={{color: "red"}}>{contacts.length === 0 ? "Porfavor ingresa al menos un contacto..." : ""}</h4>

			{/*MODAL FOR ADD A CONTACT*/}
			<ContactModal
				title={"Agregar un Contacto"}
				contacts={contacts}
				openModal={openAddContactModal}
				setOpenModal={setAddContactOpenModal}
				onNewContact={(value) => addNewContact(value)}
			/>

			{/*MODAL FOR EDIT A CONTACT*/}
			<ContactModal
				title={"Editar un Contacto"}
				contacts={contacts}
				openModal={openEditContactModal}
				setOpenModal={setEditContactOpenModal}
				onNewContact={(value) => editContact(value)}
				contactDataToEdit={contactSelected}
			/>
		</>
	);
};

Contacts.propTypes = {
	contacts: PropTypes.array.isRequired,
	onChangeContacts: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};
